export  default {
  path: '/media',
  name: 'Media',
  redirect: '/media/list',
  component: () => import('@/components/layout'),
  meta: { requiresAuth: true },
  children: [{
    path: 'list',
    component: () => import('@/views/media'),
    meta: { requiresAuth: true },
  },
  {
    path: 'addMedia',
    component: () => import('@/views/media/addMedia'),
    meta: { requiresAuth: true }
  },
  {
    path: 'detail',
    component: () => import('@/views/media/detail'),
    meta: { requiresAuth: true }
  }
  ]
}
